/**
 * Builds a "Add to Google Calendar" link for one event — no OAuth, no
 * server round-trip, just Google's own public event-creation URL. Works
 * for any member regardless of whether they've connected Google Calendar
 * integration at all.
 */

/** YYYYMMDDTHHmmssZ in UTC, the format Google's calendar render URL wants. */
function toGoogleUtcStamp(date) {
  return date.toISOString().replace(/[-:]|\.\d{3}/g, '');
}

/**
 * @param {object} opts
 * @param {string} opts.title
 * @param {string|Date} opts.start — event start (ISO string or Date)
 * @param {number} [opts.durationMinutes=60] — Hub events don't carry a known duration, so default to 1hr like the Zoom→Calendar push does
 * @param {string} [opts.details] — shown in the event description (e.g. the join link)
 * @returns {string}
 */
export function buildGoogleCalendarAddUrl({ title, start, durationMinutes = 60, details }) {
  const startDate = start instanceof Date ? start : new Date(start);
  const endDate = new Date(startDate.getTime() + durationMinutes * 60000);
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title || 'Hub Event',
    dates: `${toGoogleUtcStamp(startDate)}/${toGoogleUtcStamp(endDate)}`,
  });
  if (details) params.set('details', details);
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
